import WorkflowNode from "./WorkflowNode";
import { Handle, Position } from "reactflow";

const DefaultNode = ({
  stepData,
  users,
  onActionClick,
  onRemoveClick,
  onParallelAddClick,
  onSerialAddClick,
  onAutoStepClick,
  onChangeTitle,
  onFinishClick,
  onChangeDuration,
  isEditing,
  isEndNode,
  translate,
}) => {
  return (
    <div>
      <Handle
        type="target"
        position={Position.Top}
        id={`TargetTop${stepData.step_code}`}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`SourceRight${stepData.step_code}`}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`SourceLeft${stepData.step_code}`}
      />
      <Handle
        type="target"
        position={Position.Right}
        id={`TargetRight${stepData.step_code}`}
      />
      <Handle
        type="target"
        position={Position.Left}
        id={`TargetLeft${stepData.step_code}`}
      />
      <WorkflowNode
        translate={translate}
        stepData={stepData}
        users={users}
        handleActionClick={onActionClick}
        handleRemoveClick={onRemoveClick}
        handleParallelAddClick={onParallelAddClick}
        handleSerialAddClick={onSerialAddClick}
        handleAutoStepClick={onAutoStepClick}
        handleChangeTitle={onChangeTitle}
        handleFinishClick={onFinishClick}
        handleDuration={onChangeDuration}
        isEditing={isEditing}
        isEndNode={isEndNode}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id={`SourceBottom${stepData.step_code}`}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`SourceLeft${stepData.step_code}`}
      />
    </div>
  );
};

export default DefaultNode;
